/**
 * RMC 2026–2027 race series configuration.
 * All times are in the source timezone defined below.
 */

export const RMC_CONFIG = {
  /** IANA timezone in which the official schedule is published */
  sourceTimezone: 'Europe/Paris', // CET (UTC+1 winter) / CEST (UTC+2 summer)

  /**
   * Weekly race schedule.
   * Keys are arbitrary day identifiers used in the UI.
   * Values are arrays of "HH:MM" strings in sourceTimezone.
   */
  schedule: {
    wednesday: ['08:15', '12:15', '16:15', '18:15', '20:15'],
    thursday:  ['08:45', '12:45', '16:45', '18:45', '20:45'],
  },

  /** Reference date used to resolve DST when converting times (championship is Nov–Mar = winter) */
  referenceDate: new Date(Date.UTC(2027, 0, 6)), // 6 Jan 2027 — stable winter date

  /** Maps schedule keys to JS day-of-week numbers (0=Sun … 6=Sat) */
  dowMap: {
    wednesday: 3,
    thursday:  4,
  },

  season: '2026–2027',
  startDate: '2026-11-02',
  endDate:   '2027-03-31',
};

export const RMC_TRAINERS = {
  classA: [
    { group: 'Van Rysel', models: ['RCR'] },
    { group: 'Wahoo', models: ['Kickr V5', 'Kickr V6', 'Kickr Move', 'Kickr Bike V1', 'Kickr Bike V2', 'Kickr Bike Shift', 'Kickr Core'] },
    { group: 'Tacx', models: ['Neo', 'Neo 2T', 'Neo 3M', 'Neo Bike', 'Neo Bike Plus'] },
    { group: 'Elite', models: ['Justo', 'Justo 2', 'Direto X', 'Direto XR', 'Direto XR-T', 'Avanti'] },
    { group: 'Thinkrider', models: ['X7 Pro', 'X2', 'X2 Max'] },
    { group: 'Cycplus', models: ['T2', 'T7'] },
    { group: 'APX', models: ['APX Pro', 'APXComp'] },
    { group: 'WattBike', models: ['Atom'] },
    { group: 'Zycle', models: ['Zbike 2.0'] },
  ],
  classB: [
    { group: 'Tacx', models: ['Flux-S', 'Flux 2'] },
    { group: 'Elite', models: ['Suito', 'Suito-T', 'Rampa', 'Rivo'] },
    { group: 'Jet Black', models: ['Volt'] },
    { group: 'ZDrive', models: ['ZDrive'] },
  ],
};

// Power categories are shared platform-wide — see constants/powerGroups.js
export { POWER_CATEGORIES as RMC_POWER_CATEGORIES, getPowerCategory } from './powerGroups';

// cat: category label, minAge: inclusive, maxAge: inclusive (null = no upper bound)
export const RMC_AGE_CATEGORIES_MEN = [
  { cat: 'M1', minAge: 17, maxAge: 29 },
  { cat: 'M2', minAge: 30, maxAge: 39 },
  { cat: 'M3', minAge: 40, maxAge: 49 },
  { cat: 'M4', minAge: 50, maxAge: 59 },
  { cat: 'M5', minAge: 60, maxAge: 64 },
  { cat: 'M6', minAge: 65, maxAge: 69 },
  { cat: 'M7', minAge: 70, maxAge: 74 },
  { cat: 'M8', minAge: 75, maxAge: null },
];

export const RMC_AGE_CATEGORIES_WOMEN = [
  { cat: 'W1', minAge: 17, maxAge: 29 },
  { cat: 'W2', minAge: 30, maxAge: 44 },
  { cat: 'W3', minAge: 45, maxAge: 59 },
  { cat: 'W4', minAge: 60, maxAge: null },
];

export function getUserAgeCategory(age, gender) {
  if (!age || !gender) return null;
  const cats = gender === 'female' ? RMC_AGE_CATEGORIES_WOMEN : RMC_AGE_CATEGORIES_MEN;
  return cats.find(c => age >= c.minAge && (c.maxAge === null || age <= c.maxAge)) || null;
}
